// TODO: detect if menu items are slotted and add class to ul

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-form-textarea',
  styleUrl: 'form.css',
  shadow: false,
})
export class FormTextarea {
  @Prop() textareaName: string = 'textareatName';
  @Prop() textareaId: string = 'textareaID';
  @Prop() textareaPlaceholder: string = 'Placeholder Text';
  @Prop() textareaRows: number = 5;
  @Prop() textareaCols: number = 33;

  render() {
    return (
      <div class="form_response">
        <textarea id={this.textareaId} name={this.textareaName} rows={this.textareaRows} cols={this.textareaCols} placeholder={this.textareaPlaceholder}>
          <slot />
        </textarea>
        <slot />
      </div>
    );
  }
}
